import React, { useEffect, useRef, useState } from "react";
import { Box, Image, Flex, Spacer } from "@chakra-ui/react";
import logo from "../assets/logo.png";
import NotificationSettings from "./NotificationSettings";

type Props = {};

const Header = () => {
  const scrollRef = useRef<HTMLDivElement>(null);
  const [scroll, setScroll] = useState(10);

  useEffect(() => {
    setScroll(window.scrollY);
    window.addEventListener("scroll", () => setScroll(window.scrollY));
  }, []);

  return (
    <Box
      position="fixed"
      zIndex={100}
      top={0}
      left={0}
      w="full"
      p={scroll > 25 ? 5 : 8}
      pb={scroll > 25 ? undefined : 0}
      bg={"gray.800"}
      boxShadow={scroll > 25 ? "md" : "none"}
      transition=".2s box-shadow"
    >
      <Flex
        justifyContent={scroll > 25 ? "start" : "center"}
        alignItems="center"
      >
        <Image
          src={logo}
          h={scroll > 25 ? "48px" : 100}
          mt={scroll > 25 ? 0 : 3}
          transition=".4s all"
        />
      </Flex>
      <NotificationSettings />
    </Box>
  );
};

export default Header;
